module.exports = "<p>\n  company-dashboard works!\n</p>\n"